import { KeyFacet, subKeyPart } from '@ms/items-view/lib/private/models/KeyFacet';
import { driveItemKeyFacet } from './DriveItemKeyFacet';

export const driveAnalyticsItemKeyFacet: KeyFacet<{
  driveItemKey: {
    endpoint: string;
    driveId?: string;
    itemId?: string;
  };
}> = new KeyFacet('driveAnalyticsItem', {
  driveItemKey: subKeyPart(driveItemKeyFacet)
});
